import { createSlice } from '@reduxjs/toolkit';
import { BlogPost } from '../models/blog/BlogPost';
import blogPostsData from '../data/blog/blog-posts.json';

interface BlogDataState {
  data: BlogPost[];
  loading: boolean;
  error: string | null;
}

const initialState: BlogDataState = {
  data: blogPostsData as BlogPost[],
  loading: false,
  error: null,
};

const blogDataSlice = createSlice({
  name: 'blog',
  initialState,
  reducers: {},
});

export default blogDataSlice.reducer;
